import { ref, Ref } from 'vue';
import { Colors } from '@/components/GamePlay/Common/data/Colors';

// Use the Color interface from the Colors file
interface Color {
  name: string;
  hex: string;
  rgb: [number, number, number];
}

export function useColors(): { colors: Ref<Color[]> } {
  const colors: Ref<Color[]> = ref(Colors);

  // You can add more reactive properties or methods here if needed

  return {
    colors,
  };
}
